import i18n from 'i18n';
import { domainValidationReg, ipValidationReg, urlRegexp } from 'regexp';
import * as Yup from 'yup';

import { CountryCode } from '@components';
import { ConditionOperatorType, ConditionVariableType } from '@enums';

const isUsingOperatorSchema = (operator) =>
  [
    ConditionOperatorType.notPrefixMatches,
    ConditionOperatorType.prefixMatches,
    ConditionOperatorType.stringNotEqual,
    ConditionOperatorType.stringEqual,
  ].includes(operator);

export const variableValidateSchema = (field, operator, optionList) => {
  switch (field) {
    case ConditionVariableType.URI:
      return isUsingOperatorSchema(operator)
        ? Yup.string().matches(urlRegexp, () => i18n.t(`validation:format.${field}`))
        : Yup.string();
    case ConditionVariableType.HostName:
      return isUsingOperatorSchema(operator)
        ? Yup.string()
            .matches(domainValidationReg, () => i18n.t(`validation:format.${field}`))
            .test('domain-validation', i18n.t('validation:route.hostnameNotMatch'), function (hostname) {
              const validateDomain = (allowedDomain: string) => {
                if (!allowedDomain.startsWith('*.')) {
                  return allowedDomain === hostname;
                }

                const baseDomain = allowedDomain.substring(1);
                const isValidSubdomain =
                  hostname?.endsWith(baseDomain) && hostname.split('.').length === allowedDomain.split('.').length;

                return isValidSubdomain;
              };

              const isValidHostname = optionList.some(({ value }) => validateDomain(value));

              return (
                isValidHostname ||
                this.createError({
                  message: i18n.t('validation:route.hostnameNotMatch'),
                })
              );
            })
        : Yup.string();
    case ConditionVariableType.ClientAddress:
      return isUsingOperatorSchema(operator)
        ? Yup.string().matches(ipValidationReg, () => i18n.t(`validation:format.${field}`))
        : Yup.string();
    case ConditionVariableType.ClientCountry:
      return isUsingOperatorSchema(operator)
        ? Yup.string().test(
            'is-valid-country-code',
            () => i18n.t(`validation:format.${field}`),
            (value) => {
              if (!value) return true; // Allow empty values, adjust if needed
              return Object.values(CountryCode).includes(value as CountryCode);
            },
          )
        : Yup.string();
    default:
      return Yup.string();
  }
};
